$(function() {
	if (!$body.hasClass('page-template-page-specials'))
		return;

	$('.call_to_action').mouseenter(function(){
		$(this).parent().parent().addClass('white');
	}).mouseleave(function(){
		$(this).parent().parent().removeClass('white');
	});

	var sliders = $('.specials_page .slides');
	var loadedCount = 0;
	var specials = $('.special');

	sliders.each(function() {
		initializeSlick(this, {
			dots: false,
			infinite: true,
			speed: 700,
			slidesToShow: 1,
			arrows: true,
			fade: true,
			nextArrow: '<button class="slider_arrow next_arrow white">Next</button>',
			prevArrow: '<button class="slider_arrow prev_arrow white">Previous</button>',
			focusOnSelect: true,
		}, function() {
			loadedCount += 1;
			if (loadedCount == sliders.length) {
				slidersBuilt();
			}
		});
	});


	function slidersBuilt() {
		$window.trigger('resize');

		specials.each(function(i) {
			if (i%2 == 0 || i == 0) {
				$(this).addClass('even');
			} else {
				$(this).addClass('odd');
			}
		});

		setInterval(function() {
			$window.trigger('resize');
		}, 500);
	}

	$(window).on('panelsLoaded', function() {
		specials.addClass('appear');
	});

	specials.find('.button').click(function(e) {
		e.stopPropagation();
	});

});